<template>
  <el-row>
    <el-col :span="24">
      <el-card class="login" shadow="always">
        <div slot="header" class="login__header">
          <img id="logo" src="@/assets/images/logo_blue.svg" />
        </div>
        <div>
          <el-form ref="form" :model="form" @submit.prevent="login">
            <el-form-item>
              <el-input
                placeholder="Username"
                v-model.trim="form.username"
                @keyup.enter.native="login(form)"
                required
                name="username"
              />
            </el-form-item>
            <el-form-item>
              <el-input
                placeholder="Password"
                v-model.trim="form.password"
                required
                type="password"
                @keyup.enter.native="login(form)"
                name="password"
                show-password
              />
            </el-form-item>
          </el-form>
          <div class="login__footer">
            <router-link to="/auth/forgot-password">
              Forgot Password
            </router-link>
            <el-button
              type="primary"
              class="btn-main"
              :loading="loading"
              @click="login(form)"
            >
              Login
            </el-button>
          </div>
        </div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },

  computed: {
    ...mapState('auth', ['loading'])
  },

  methods: {
    ...mapActions('auth', ['login'])
  }
}
</script>

<style lang="scss" scoped>

.login {
  margin: 17vh auto;
  width: auto;
  max-width: 25rem;
  max-height: 20rem;
  text-align: center;

  #logo {
    width: 180px;
    padding-right: 1rem;
    vertical-align: middle;
  }

  &__header {
    padding: 15px 20px;
  }

   &__footer {
    margin: 40px 0 15px;
    display: flex;
    justify-content: space-between;

     a {
      font-size: 14px;
    }
  }
}

@media screen and (max-width: 800px) and (orientation: landscape) {
  .login {
    margin: 5vh auto;
  }
}

</style>
